import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import Config from '../../../Config';
import './businessPartner.scss';
import SwiperCore, {EffectFade, Navigation, Autoplay} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {style} from 'd3';

SwiperCore.use([Navigation, EffectFade, Autoplay]);

const MainBusinessPartners = (props) => {
  const title = props.iContent?.mainTitle?.value;
  const subtitle = props.iContent?.subTitle?.value;
  const showBtn = props.iContent?.showBtn?.value;
  const linkText = props.iContent?.linkText?.value;
  const link = props.iContent?.link?.value;
  const currentPartners = props.iContent?.currentPartners?.expandedValue;
  const newPartners = props.iContent?.newPartners?.expandedValue;
  const [swiperInstence, setSwiperInstence] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [item, setItem] = useState(null);
  const [index, setIndex] = useState(-1);
  const [indexNewPartner, setIndexNewPartner] = useState(-1);
  const [selectedRow, setSelectedRow] = useState(-1);
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [showMobileCurrentPartners, setMobileShow] = useState(true);
  const newPartnersMobile = props.iContent?.newPartnersMobile?.expandedValue;

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const setInfo = (info) => {
    setItem(info);
    if (info == null) {
      setIndex(-1);
      setSelectedRow(-1);
    }
  };

  const getFittedImg = (obj) => {
    if (windowSize > 1500) {
      return obj?.imageDesktopMedium?.expandedValue?.url ?? obj?.imageDesktop?.expandedValue?.url;
    }
    return obj?.imageDesktop?.expandedValue?.url;
  };

  const len = parseInt(currentPartners.length / 2);
  const size = currentPartners.length;
  let startRow1 = 0;
  let endRow1 = parseInt(size - size / 2);
  let startRow2 = endRow1 + 1;
  let endRow2 = size - 1;

  const infoConditions = (elementIndex) => {
    if (size > 5) {
      return elementIndex % (size < 12 ? 6 : endRow1) <= 4;
    }
    return elementIndex != size - 1;
  };
  return (
    <div className='main-business-partner'>
      <div className='title'>{title}</div>
      <div className='sub-title'>{subtitle}</div>
      <div className='new-items'>
        {!isMobile &&
          newPartners != null &&
          newPartners.map((item, i) => (
            <>
              <div
                className={`${newPartners?.length > 1 ? 'desktop-new-partner' : 'single-desktop-new-partner'} new-item`}
                key={i}
                onClick={() => {
                  setInfo(item);
                }}
                onMouseLeave={() => {
                  setInfo(null), setIndexNewPartner(-1);
                }}
                onMouseEnter={() => {
                  setInfo(item), setIndexNewPartner(i);
                }}>
                <Image src={
                    !isMobile ? Config.epiBaseUrl + getFittedImg(item) : Config.epiBaseUrl + item?.imageMobile?.expandedValue?.url
                  } />
                <div className={`${indexNewPartner != -1 ? 'hidden' : ''} new-item-text`}>{'שותף עסקי חדש'}</div>

                {!isMobile && item != null && indexNewPartner == i && (
                  <div className={`${indexNewPartner == 1 || indexNewPartner == 2 ? 'right' : ''} show-info-new-partner-desktop`}>
                    <div className='show-info-img'>
                      <div className='img-location'>
                        <Image src={Config.epiBaseUrl + item?.imageMobile?.expandedValue?.url} />
                      </div>
                    </div>
                    <div className='info-txt' dangerouslySetInnerHTML={{__html: item?.info?.value}}></div>
                  </div>
                )}
              </div>
            </>
          ))}
        {isMobile &&
          newPartnersMobile != null &&
          newPartnersMobile?.length == 1 &&
          newPartnersMobile.map((item, i) => (
            <>
              <div
                className='new-item'
                key={i}
                onClick={() => {
                  setMobileShow(false);
                  setInfo(item);
                }}>
                <Image src={
                    !isMobile
                      ? Config.epiBaseUrl + item?.imageDesktop?.expandedValue?.url
                      : Config.epiBaseUrl + item?.imageMobile?.expandedValue?.url
                  } />
                <div className='new-item-text'>{'שותף עסקי חדש'}</div>
              </div>
            </>
          ))}

        {isMobile && newPartnersMobile != null && newPartnersMobile?.length > 1 && (
          <Swiper
            slidesPerView={1}
            autoplay={{
              delay: 2000,
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            onSwiper={(swiper) => {
              setSwiperInstence(swiper);
            }}
            effect='slide'
            onSlideChange={(swiper) => {
              setActiveIndex(swiper?.activeIndex);
            }}>
            {newPartnersMobile.map((item, i) => (
              <SwiperSlide key={i} className='slides-box'>
                <div
                  className={`${isMobile ? 'swiper-new-item' : ''} new-item`}
                  key={i}
                  onClick={() => {
                    setMobileShow(false);
                    setInfo(item);
                  }}>
                  <Image src={
                      !isMobile
                        ? Config.epiBaseUrl + item?.imageDesktop?.expandedValue?.url
                        : Config.epiBaseUrl + item?.imageMobile?.expandedValue?.url
                    } />
                  <div className='new-item-text'>{'שותף עסקי חדש'}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
      <div
        style={{visibility: showMobileCurrentPartners ? 'visible' : 'hidden'}}
        className={`swiper-area ${!isMobile && 'swiper-desktop-adjustment'}`}>
        <Swiper
          navigation={currentPartners?.length > 12 && !isMobile ? true : false}
          slidesPerView={isMobile ? 3 : 6}
          centerInsufficientSlides={true}
          slidesPerColumn={2}
          slidesPerColumnFill='row'
          onSwiper={(swiper) => {
            setSwiperInstence(swiper);
          }}
          effect='slide'
          onSlideChange={(swiper) => {
            setActiveIndex(swiper?.activeIndex);
          }}>
          {!isMobile &&
            currentPartners != null &&
            currentPartners?.map((obj, j) => (
              <>
                <SwiperSlide
                  key={j}
                  className={`slides-box ${(selectedRow == 1 && j <= len) || (j > len && selectedRow == 2) ? `decrease` : `increase`} `}>
                  <div
                    className={`item-style ${windowSize > 1500 && 'large-screen'}`}
                    onClick={() => {
                      setInfo(obj), setIndex(j), setSelectedRow(j >= 0 && j <= len ? 1 : 2);
                    }}
                    onMouseLeave={() => {
                      setSelectedRow(-1), setInfo(null), setIndex(-1);
                    }}
                    onMouseEnter={() => {
                      setInfo(obj), setIndex(j), setSelectedRow(j >= 0 && j <= len ? 1 : 2);
                    }}>
                    <div className='img-location'>
                      <Image src={
                          !isMobile ? Config.epiBaseUrl + getFittedImg(obj) : Config.epiBaseUrl + obj?.imageMobile?.expandedValue?.url
                        } />
                    </div>

                    {!isMobile && item != null && index == j && (
                      <div className={infoConditions(j) ? 'show-info-desktop' : 'show-info-desktop-last'}>
                        <div className='show-info-img'>
                          <div className='img-location'>
                            <Image src={Config.epiBaseUrl + item?.imageMobile?.expandedValue?.url} />
                          </div>
                        </div>
                        <div className='info-txt' dangerouslySetInnerHTML={{__html: item?.info?.value}}></div>
                      </div>
                    )}
                  </div>
                </SwiperSlide>
              </>
            ))}

          {isMobile &&
            currentPartners != null &&
            currentPartners?.map((obj, j) => (
              <>
                <SwiperSlide key={j} className='slides-box'>
                  <div
                    className='item-style'
                    onClick={() => {
                      setMobileShow(false);
                      setInfo(obj);
                    }}>
                    <div className='img-location'>
                      <Image src={Config.epiBaseUrl + obj?.imageMobile?.expandedValue?.url} />
                    </div>
                  </div>
                </SwiperSlide>
              </>
            ))}
        </Swiper>
      </div>
      {isMobile && item != null && (
        <div className='show-info-mobile'>
          <div className='show-info-img'>
            <div className='img-location'>
              <Image src={Config.epiBaseUrl + item?.imageMobile?.expandedValue?.url} />
            </div>
            <div
              className='close-location'
              onClick={() => {
                setMobileShow(true);
                setInfo(null);
              }}>
              <Image src={require('./images/close.svg')} />
            </div>
          </div>
          <div className='info-txt' dangerouslySetInnerHTML={{__html: item?.info?.value}}></div>
        </div>
      )}

      {showBtn && (
        <div className='btn'>
          {linkText.trim() && <BtnSubmit isBusiness text={linkText} onclick={() => {
            props.context.navigateTo(link);
            window.scrollTo(0, 0);
            }} />}
        </div>
      )}
    </div>
  );
};

export default MainBusinessPartners;
